import View from '../../../Core/View.js';

class Legend extends View {
	initialize(options) {
		this.categoryList = options.categoryList;
		this.dataRoute = options.routeData;
		this._createLegend(this.categoryList)
	}

	_createLegend(jsonList) {
		for (let key in jsonList) {
			if (this._routeNameIsNotHeadQuarterOrUndefined(key) && this._shouldBeRouteDisplayed(key)) {
				this._newLegendCategoryElement(jsonList[key]);
			}
		}
	};

	_routeNameIsNotHeadQuarterOrUndefined(categoryName) {
		const invalidCategoryNames = [
			'Sloepdelen steiger',
			'Untitled layer',
			'Sloepdelen',
		];
		return invalidCategoryNames.indexOf(categoryName) === - 1;
	}

	_shouldBeRouteDisplayed(categoryName) {
		return ! (this.dataRoute === null && categoryName === 'Routes');
	}

	_newLegendCategoryElement(object) {
		const name = this._returnValidNameToLegendCatrgory(object)
		const color = this._returnValidColorToLegendCategory(object)
		const div = document.createElement('div');
		div.classList.add('location-map__legend-container__category-holder');
		div.innerHTML = `<div class='location-map__legend-container__category-holder__category'>${this._addRightIcon(name, color)}</div>${name}`;
		this.el.appendChild(div);
	}

	_returnValidNameToLegendCatrgory(object) {
		if (object.name === "Routes") {
			return this.dataRoute.name;
		}
		return object.name;
	}

	_returnValidColorToLegendCategory(object) {
		if (object.name === "Routes") {
			return this.dataRoute.color
		}
		return object.color;
	}

	_addRightIcon(name, color) {
		if (this.dataRoute.routesNames.indexOf(name) === - 1) {
			return `<div style="background-color:#${color}" class="location-map__legend-container__category-holder__category__circle-icon"></div>`;
		}
		return `<div style="background-color:#${color}" class="location-map__legend-container__category-holder__category__route-icon"></div>`;
	}
}

export default Legend;


// WEBPACK FOOTER //
// ./js/Views/Modules/LocationMap/Legend.js